import { Icon, Table, ControlledPopup, EllipsisDropdown, USER_PERMISSIONS } from "dyl-components";
import React from "react";
import { Controller } from "react-hook-form";
import {
    DropdownItem,
    Form,
    Input,
    Label,
    Header,
} from "semantic-ui-react";
import RestrictedView from "shared/RestrictedView";

const DataRow = ({
    item,
    index,
    isEditing,
    control,
    getValues,
    update,
    setEditMode,
    remove,
    onDeleteConfirm,
    watch,
}) => {
    return (
        <Table.Row>
            <Table.Cell width={4}>
                {isEditing ? (
                    <Controller
                        name={`urls.${index}.name`}
                        control={control}
                        render={({ field, fieldState: { error } }) => (
                            <Form.Field
                                placeholder="Name"
                                required
                                error={!!error?.message}
                            >
                                <Input
                                    {...field}
                                    value={field?.value || ""}
                                    placeholder="Name *"
                                />

                                {error?.message && (
                                    <Label basic color="red" pointing="above">
                                        {error?.message}
                                    </Label>
                                )}
                            </Form.Field>
                        )}
                    />
                ) : (
                    item?.name || getValues?.()?.urls?.[index]?.name
                )}
            </Table.Cell>

            <Table.Cell width={7}>
                {isEditing ? (
                    <Controller
                        name={`urls.${index}.url`}
                        control={control}
                        render={({ field, fieldState: { error } }) => (
                            <Form.Field
                                placeholder="URL *"
                                required
                                error={!!error?.message}
                            >
                                <Input
                                    {...field}
                                    value={field?.value || ""}
                                    placeholder="URL"
                                />
                                {error?.message && (
                                    <Label basic color="red" pointing="above">
                                        {error?.message}
                                    </Label>
                                )}
                            </Form.Field>
                        )}
                    />
                ) : (
                    item?.url || getValues?.()?.urls?.[index]?.url
                )}
            </Table.Cell>

            <Table.Cell width={4}>
                {isEditing ? (
                    <>
                        <Icon
                            name="close"
                            color="red"
                            size="large"
                            onClick={() => {
                                if (watch(`urls.${index}.name`) || watch(`urls.${index}.url`)) {
                                    setEditMode(index, false);
                                } else {
                                    remove?.(index);
                                    setEditMode(index, false);
                                }
                            }}
                            style={{ cursor: "pointer" }}
                        />
                        <Icon
                            name="check"
                            color="blue"
                            className="callerID-action-icon"
                            size="large"
                            onClick={() => {
                                update?.(index, getValues?.()?.urls?.[index]);
                                setEditMode(index, false);
                            }}
                            disabled={
                                !watch(`urls.${index}.name`) ||
                                !watch(`urls.${index}.url`) ||
                                (item?.name === watch(`urls.${index}.name`) && item?.url === watch(`urls.${index}.url`))
                            }
                        />
                    </>
                ) : (
                    <EllipsisDropdown>
                        <RestrictedView userPermission={USER_PERMISSIONS.USER_PROFILE_PREFERENCES_EDIT} type="disabled" userRestrict>
                            <DropdownItem
                                onClick={() => setEditMode(index, true)}
                            >
                                <Icon name="pencil alternate" size="large" />
                                Edit
                            </DropdownItem>
                        </RestrictedView>
                        <RestrictedView userPermission={USER_PERMISSIONS.USER_PROFILE_PREFERENCES_DELETE} type="controlledPopupDisabled" userRestrict>
                            <ControlledPopup
                                header={<Header as='h4' textAlign='center'>
                                    Are you sure?
                                    <Header.Subheader style={{ marginTop: 5 }}>
                                        You cannot undo delete actions.
                                    </Header.Subheader>
                                </Header>}
                                trigger={
                                <DropdownItem>
                                    <Icon name="trash" size="large" />
                                        Delete
                                </DropdownItem>
                                }
                                onConfirm={() => onDeleteConfirm(index) } 
                            />
                        </RestrictedView>
                    </EllipsisDropdown>
                )}
            </Table.Cell>
        </Table.Row>
    );
};

export default DataRow;
